/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useRef, useEffect } from "react";
import { Input } from "reactstrap";

const SearchField = (props) => {
  const [searchValue, setSearchValue] = useState(props.value || '');
  const inputRef = useRef(null);

  useEffect(() => {
    // Set focus on the input when component mounts or when searchValue changes
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchValue]);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    if (props.onSearch) {
      props.onSearch(value);
    }
  };

  return (
    <div className="search-max-width mb-4">
      <div className="form-icon left">
        <Input
          innerRef={inputRef}
          type="search"
          className="form-control form-control-icon"
          value={searchValue}
          onChange={handleSearch}
          id="iconrightInput"
          placeholder="Search...."
          autoFocus
        />
        <i className="ri-search-line"></i>
      </div>
    </div>
  );
};

export default SearchField;
